<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/gym_booking/"
                       data-key="bookings"
                       :extra-params="{user_id: userId}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.reference_number="{value}">
      {{ "GYM" + value.toString().padStart(10, '0') }}
    </template>
    <template v-slot:item.account="{value}">
      {{ $t('name', {given_name: value.given_name, surname: value.surname}) }}
    </template>
    <template v-slot:item.date="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template v-slot:item.checkin_time="{value}">
      <v-icon v-if="value">fas fa-check</v-icon>
    </template>
    <template v-slot:item.status="{value}">
      {{ $t(BOOKING_STATUS_LABEL[value]) }}
    </template>
    <!--    <template v-slot:item.actions="{item}">-->
    <!--      <v-btn icon color="primary"-->
    <!--             v-if="item.status === 1 && !item.checkin_time"-->
    <!--             @click="cancelBooking(item)">-->
    <!--        <v-icon>fas fa-trash</v-icon>-->
    <!--      </v-btn>-->
    <!--    </template>-->
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS_LABEL} from "@/constants";

export default {
  name: 'AdminGymBookingList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    userId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('gym_booking.reference_number'), value: 'reference_number', contains: true},
        {text: root.$t('gym_booking.date'), value: 'date', datetime_date_range: true},
        // {text: root.$t('gym_booking.checkin_time'), value: 'checkin_time'},
        {
          text: root.$t('gym_booking.booking_status'), value: 'status',
          options: Object.keys(BOOKING_STATUS_LABEL).map((k) => {
            return {text: root.$t(BOOKING_STATUS_LABEL[k]), value: k}
          })
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('gym_booking.reference_number'), value: 'reference_number'},
      {text: root.$t('gym_booking.account'), value: 'account'},
      {text: root.$t('gym_booking.date'), value: 'date'},
      {text: root.$t('gym_booking.checkin_time'), value: 'checkin_time'},
      {text: root.$t('gym_booking.booking_status'), value: 'status'},
      {text: '', value: 'actions'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,

      BOOKING_STATUS_LABEL,
    }
  }
}
</script>
